import {CompetitionHighlightsPageRouteMetaDataModel} from "./competition-highlights-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionHighlightsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.highlights,
      path: `highlights`,
      componentImport: () => import("../components/competition-highlights-page" /* webpackChunkName: "competition-highlights-page" */ ),
      metadataType: CompetitionHighlightsPageRouteMetaDataModel
    });
  }
}
